import axios from "axios";

import {
  updateAccessToken,
  resetAuthSession,
  getToken,
  getRefreshToken,
} from "utils/UserHelper";

const service = axios.create({
  baseURL: `${process.env.REACT_APP_API_BASE_URL}`,
  responseType: "application/json",
  contentType: "application/json",
});

service.interceptors.request.use(
  async (config) => {
    try {
      const updatedConfig = config;
      if (!updatedConfig.ignoreToken) {
        const token = getToken();
        if (token)
          updatedConfig.headers.common.Authorization = `Bearer ${token}`;
      }

      delete updatedConfig.ignoreToken;
      return updatedConfig;
    } catch (err) {
      return Promise.reject(err);
    }
  },
  (error) => {
    console.log(error);
    return Promise.reject(error);
  }
);

service.interceptors.response.use(undefined, async (err) => {
  const originalConfig = err.config;
  if (!!err?.response) {
    console.log("service.interceptors.", err.response);
    // api generated errors
    const { status, data } = err.response;
    const { error, validationErrors, message } = data;
    if (status === 401 && !originalConfig._retry) {
      // Unauthorized access
      resetAuthSession();
      // user is not authorized
      originalConfig._retry = true;
      try {
        const refreshToken = getRefreshToken();
        const rs = await service.post("/identity-service/auth/refresh", {
          refreshToken,
        });
        // console.log("refresh", rs);
        if (rs && rs.status === 200) {
          const { accessToken } = rs.data;
          if (accessToken) {
            updateAccessToken(accessToken);
            return service(originalConfig);
          }
        } else {
          resetAuthSession();
          // window.location.reload()
        }
      } catch (_error) {
        return Promise.reject(_error);
      }
    } else if (
      (status >= 400 && status < 500) ||
      error === "Validation error"
    ) {
      //  Validation error
      console.log("4xx error", validationErrors);
      if (validationErrors && validationErrors.length > 0) {
        return {
          message,
          status,
          validationErrors,
        };
      } else {
        return {
          message,
          status,
        };
      }
    } else if (status === 500) {
      console.log(error);
      return {
        status,
        message,
      };
    }
    // add more as you go
  } else {
    return {
      err,
      status: 500,
    };
  }
});

export default service;
